function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["view", "position", "fallbackPlacements", "on", "isArrow", "width", "maxWidth", "padding", "offset", "offsetSkidding", "duration", "isOpen", "onOpen", "onClose", "children", "isClosable", "isDisabled", "targetRef"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import offsetModifier from '@popperjs/core/lib/modifiers/offset';
import arrowModifier from '@popperjs/core/lib/modifiers/arrow';
import flipModifier from '@popperjs/core/lib/modifiers/flip';
import { usePopper } from './usePopper';
import { Arrow, Container, Wrapper, Inner, ButtonWrapper } from './styles';
import { getRootPopup } from './utils';
import { viewModalOnMobile } from './modifiers';
import { isBrowser, isMobile } from '../../utils';
import { Button } from '../../components/Button';
import { IconSvg } from '../../components/IconSvg';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
export var Tooltip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$view = props.view,
    view = _props$view === void 0 ? 'default' : _props$view,
    _props$position = props.position,
    position = _props$position === void 0 ? 'top' : _props$position,
    _props$fallbackPlacem = props.fallbackPlacements,
    fallbackPlacements = _props$fallbackPlacem === void 0 ? ['top', 'bottom', 'right', 'left'] : _props$fallbackPlacem,
    _props$on = props.on,
    on = _props$on === void 0 ? 'click' : _props$on,
    _props$isArrow = props.isArrow,
    isArrow = _props$isArrow === void 0 ? true : _props$isArrow,
    _props$width = props.width,
    width = _props$width === void 0 ? 'auto' : _props$width,
    _props$maxWidth = props.maxWidth,
    maxWidth = _props$maxWidth === void 0 ? 320 : _props$maxWidth,
    _props$padding = props.padding,
    padding = _props$padding === void 0 ? [15, 20] : _props$padding,
    _props$offset = props.offset,
    offset = _props$offset === void 0 ? 18 : _props$offset,
    _props$offsetSkidding = props.offsetSkidding,
    offsetSkidding = _props$offsetSkidding === void 0 ? 0 : _props$offsetSkidding,
    _props$duration = props.duration,
    duration = _props$duration === void 0 ? 300 : _props$duration,
    _props$isOpen = props.isOpen,
    isOpenProp = _props$isOpen === void 0 ? false : _props$isOpen,
    onOpen = props.onOpen,
    onClose = props.onClose,
    children = props.children,
    isClosable = props.isClosable,
    isDisabled = props.isDisabled,
    targetRef = props.targetRef,
    other = _objectWithoutProperties(props, _excluded);
  var config = {
    placement: position,
    strategy: 'fixed',
    modifiers: [offsetModifier, arrowModifier, flipModifier, viewModalOnMobile, {
      name: 'offset',
      options: {
        offset: [offsetSkidding, offset]
      }
    }, {
      name: 'arrow',
      options: {
        padding: 20
      }
    }, {
      name: 'flip',
      options: {
        padding: 0,
        fallbackPlacements: fallbackPlacements || undefined
      }
    }]
  };
  var _usePopper = usePopper(config, [children, width], !isDisabled && isOpenProp, targetRef),
    triggerRef = _usePopper.triggerRef,
    popupRef = _usePopper.popupRef,
    innerRef = _usePopper.innerRef,
    isOpen = _usePopper.isOpen,
    showHandler = _usePopper.showHandler,
    hideHandler = _usePopper.hideHandler,
    create = _usePopper.create,
    destroy = _usePopper.destroy;
  var handleEnter = function handleEnter() {
    create();
    onOpen === null || onOpen === void 0 ? void 0 : onOpen();
  };
  var triggerProps = {
    ref: triggerRef
  };
  if (on === 'hover' && !isMobile()) {
    triggerProps.onMouseEnter = showHandler;
    triggerProps.onMouseLeave = hideHandler;
  } else {
    triggerProps.onClick = function () {
      var _props$trigger$props, _props$trigger$props$;
      (_props$trigger$props = props.trigger.props) === null || _props$trigger$props === void 0 ? void 0 : (_props$trigger$props$ = _props$trigger$props.onClick) === null || _props$trigger$props$ === void 0 ? void 0 : _props$trigger$props$.call(_props$trigger$props);
      if (isOpen) {
        hideHandler();
      } else {
        showHandler();
      }
    };
  }
  return _jsxs(_Fragment, {
    children: [/*#__PURE__*/React.cloneElement(props.trigger, triggerProps), isBrowser && /*#__PURE__*/ReactDOM.createPortal(_jsx(CSSTransition, {
      unmountOnExit: true,
      "in": !isDisabled && isOpen,
      timeout: duration,
      onEnter: handleEnter,
      onExited: destroy,
      onExit: onClose,
      classNames: "tooltip",
      children: _jsx(Container, _objectSpread(_objectSpread({
        ref: popupRef,
        isOpen: isOpen,
        duration: duration,
        role: "tooltip"
      }, other), {}, {
        children: _jsxs(Wrapper, {
          ref: innerRef,
          isOpen: isOpen,
          duration: duration,
          width: width,
          maxWidth: maxWidth,
          children: [_jsxs(Inner, {
            ref: ref,
            view: view,
            padding: padding,
            children: [isClosable && _jsx(ButtonWrapper, {
              children: _jsx(Button, {
                size: "S",
                view: "transparent",
                shape: "circle",
                onClick: hideHandler,
                children: _jsx(IconSvg, {
                  src: "close"
                })
              })
            }), children && typeof children === 'function' ? children(hideHandler) : children]
          }), _jsx(Arrow, {
            isVisible: isArrow,
            view: view,
            "data-popper-arrow": true
          })]
        })
      }))
    }), getRootPopup())]
  });
});
//# sourceMappingURL=index.js.map